module.exports = __webpack_public_path__ + "482ecd1ae8dceca4989f846c3a4f5408.MP3";